import { Controller } from 'react-hook-form';
import { ThemeProvider } from '@emotion/react';
import CustomLabel from 'components/customLabel';
import ErrorMessage from 'components/errorMessage';
import { SelectInputStyle, SelectStyle } from './../InitialStyle/index';
import { Autocomplete, Box, TextField, createTheme } from '@mui/material';

type SelectProps = {
  data?: any;
  error?: any;
  style?: any;
  styles?: any;
  control: any;
  name: string;
  label?: string;
  clear?: boolean;
  loading?: boolean;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  defaultValue?: { label: string; id: number };
};

export default function FormSelect({
  name,
  label,
  error,
  style,
  styles,
  control,
  loading,
  disabled,
  data = [],
  placeholder,
  clear = false,
  required = true,
  defaultValue,
}: SelectProps) {
  const theme = createTheme({
    components: {
      MuiAutocomplete: {
        styleOverrides: {
          option: {
            '&[data-focus="true"]': {
              backgroundColor: 'red',
            },
          },
          root: {
            zIndex: 99999999,
            '& label': {
              fontSize: 12,
            },
          },
          input: {
            fontSize: 12,
          },
          listbox: {
            fontSize: 14,
            fontFamily: 'Lato',
            padding: '0 5px',
            borderRadius: '5px',
            '.MuiAutocomplete-option': {
              '&.Mui-focused': {
                backgroundColor: '#f0f0ff',
              },
            },
          },
        },
      },
    },
  });

  return (
    <Box sx={{ ...styles, width: '100%' }} position='relative'>
      <CustomLabel htmlFor={label}>{label}</CustomLabel>

      <Controller
        name={name}
        control={control}
        rules={{
          required: required && 'Поле, обязательное для заполнения',
        }}
        defaultValue={defaultValue}
        render={({ field: { onChange, value } }) => (
          <ThemeProvider theme={theme}>
            <Autocomplete
              disablePortal
              disabled={disabled}
              options={data}
              loading={loading}
              noOptionsText='нет данных'
              disableClearable={clear}
              sx={{
                ...SelectStyle,
                ...style,
              }}
              onChange={(_, values) => {
                onChange(values || null);
              }}
              value={value || null}
              renderInput={(params) => (
                <TextField
                  {...params}
                  error={Boolean(error?.[name]) || Boolean(error?.message)}
                  placeholder={placeholder}
                  sx={SelectInputStyle}
                />
              )}
            />
          </ThemeProvider>
        )}
      />
      <span style={{ color: 'red', fontSize: '12px', position: 'absolute', left: 0, bottom: -15 }}>
        {error?.type === 'required' && error?.message}
      </span>
      <ErrorMessage error={error} name={name} />
    </Box>
  );
}
